import {IHaveConditions} from "../PA.MD.Core/PA.MD.IF.Aspects";
import {
    WB_CustomerRow,
    WB_ProductConditionRow,
    WB_ProductConditionTypeRow,
    WB_ProductGroupRow
} from "../PA.Core/PAdbSchemaRows";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Product_Condition, esWB_Product_Condition_Type} from "../PA.Core/PAdbSchema";


export class ConditionCollection
    implements IHaveConditions
{

    private dbContext: PAdbContext
    private _conditionRecords: WB_ProductConditionRow[]
    private _conditionChanged: BehaviorSubject<IHaveConditions>
    private _dctCustomers: WB_CustomerRow[];
    private _dctProducts: WB_ProductGroupRow[]
    private _prodCndMID: number
    private _prodCndType: string

    constructor(options: {dbContext?: PAdbContext}){
        let opts = options || {}

        if('dbContext' in opts){
            this.dbContext = opts.dbContext
        } else {
            this.dbContext = new PAdbContext()
        }

        this._conditionRecords = []
        this._conditionChanged = new BehaviorSubject<IHaveConditions>(this)
        this._dctCustomers = []
        this._dctProducts = []
        this._prodCndMID = undefined
        this._prodCndType = ""
    }

    get ConditionsChanged(): BehaviorSubject<IHaveConditions> { return this._conditionChanged }

    get Conditions(): WB_ProductConditionRow[] { return this._conditionRecords }

    get Customers(): WB_CustomerRow[] { return this._dctCustomers }

    set Customers(arrCustomers: WB_CustomerRow[]) {
        this._dctCustomers = arrCustomers
    }

    get Products(): WB_ProductGroupRow[] { return this._dctProducts }

    set Products(arrProducts: WB_ProductGroupRow[]) {
        this._dctProducts = arrProducts
    }

    AddNewCondition(): Promise<WB_ProductConditionRow> {
        const self = this
        return new Promise<WB_ProductConditionRow>((resolve, error) => {

            self.dbContext.createRecordWithKey(esWB_Product_Condition)
                .then((newProductConditionRow: WB_ProductConditionRow)=> {
                    newProductConditionRow.setDefaults()
                    newProductConditionRow.cif.PROD_CNDM_ID = this._prodCndMID
                    newProductConditionRow.cif.CONDITION_TYPE = this._prodCndType
                    self.dbContext.add(esWB_Product_Condition, newProductConditionRow)
                    self._conditionRecords.push(newProductConditionRow)
                    self.notify()
                    resolve();

                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    LoadConditions(aWB_CndM_ID: number, CustomerIDs: string[], ProductIds: string[], StartDt: Date, EndDt: Date): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            var query:any = {
                PROD_CNDM_ID: aWB_CndM_ID,
                EFFECTIVE_START_DT: StartDt,
                EFFECTIVE_END_DT: EndDt
            }

            if(CustomerIDs != undefined)
                query["CUSTOMER_ID"] = {in: CustomerIDs}
            if(ProductIds != undefined)
                query["PRODUCT_ID"] = {in: ProductIds}

            self.dbContext.findAll(esWB_Product_Condition,{
                where: query
            })
                .then(function (aProductConditionRows: WB_ProductConditionRow[]) {
                    self._conditionRecords = aProductConditionRows
                    console.log("loading..")
                    //debugger

                    var aLastProdCond = self._conditionRecords[self._conditionRecords.length-1]
                    if(aLastProdCond) {
                        self._prodCndMID = aLastProdCond.cif.PROD_CNDM_ID
                        self._prodCndType = aLastProdCond.cif.CONDITION_TYPE
                    }
                    self.notify()
                    resolve()
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

    RemoveCondition(aCnd: WB_ProductConditionRow): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            console.log("removing..")
            var aCondition = self._conditionRecords.find(function(element: WB_ProductConditionRow) {
                return element.cif.PROD_CND_ID = aCnd.cif.PROD_CND_ID
            });
            aCondition.markDeleted()
            self.notify()
        })
    }

    SaveConditions(): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            self.dbContext.Save(esWB_Product_Condition, self._conditionRecords)
                .then(() => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    private notify() {
        this._conditionChanged.next(this)
    }



}